export type RegionBound = {
  prefecture: string;
  metroCenter: { lat: number; lng: number };
  metroRadiusKm: number;
};

/** Metro bounds aligned with scripts/regionConfig.js (for GPS prefecture detection). */
export const REGION_BOUNDS: RegionBound[] = [
  {
    prefecture: "Tokyo",
    metroCenter: { lat: 35.681236, lng: 139.767125 },
    metroRadiusKm: 45,
  },
  {
    prefecture: "Osaka",
    metroCenter: { lat: 34.6937, lng: 135.5023 },
    metroRadiusKm: 25,
  },
  {
    prefecture: "Nagoya",
    metroCenter: { lat: 35.1815, lng: 136.9066 },
    metroRadiusKm: 25,
  },
  {
    prefecture: "Fukuoka",
    metroCenter: { lat: 33.5904, lng: 130.4017 },
    metroRadiusKm: 60,
  },
  {
    prefecture: "Okinawa",
    metroCenter: { lat: 26.2124, lng: 127.6792 },
    metroRadiusKm: 50,
  },
  {
    prefecture: "Hong Kong",
    metroCenter: { lat: 22.3193, lng: 114.1694 },
    metroRadiusKm: 20,
  },
  {
    prefecture: "Taiwan",
    metroCenter: { lat: 25.033, lng: 121.5654 },
    metroRadiusKm: 120,
  },
  {
    prefecture: "Seoul",
    metroCenter: { lat: 37.5665, lng: 126.978 },
    metroRadiusKm: 25,
  },
  {
    prefecture: "Busan",
    metroCenter: { lat: 35.1796, lng: 129.0756 },
    metroRadiusKm: 25,
  },
  {
    prefecture: "Bangkok",
    metroCenter: { lat: 13.7563, lng: 100.5018 },
    metroRadiusKm: 25,
  },
  {
    prefecture: "Chiang Mai",
    metroCenter: { lat: 18.7883, lng: 98.9853 },
    metroRadiusKm: 20,
  },
  {
    prefecture: "Singapore",
    metroCenter: { lat: 1.3521, lng: 103.8198 },
    metroRadiusKm: 20,
  },
  {
    prefecture: "Kuala Lumpur",
    metroCenter: { lat: 3.139, lng: 101.6869 },
    metroRadiusKm: 20,
  },
  {
    prefecture: "Malaysia",
    metroCenter: { lat: 3.139, lng: 101.6869 },
    metroRadiusKm: 80,
  },
  {
    prefecture: "Sydney",
    metroCenter: { lat: -33.8688, lng: 151.2093 },
    metroRadiusKm: 40,
  },
];
